/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  selectRequestState,
  sendRequestDeleteInCustomerList,
  sendRequestDeleteInExecutorList
} from 'mt-react-common/modules/userBlackList/reducers/static/forms/removeUserBlackListForm/reduce';

import WrapperPopUp from 'components/Common/PopUps/WrapperPopUp/index';
import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';

import OpacityPreLoader from 'components/Common/PreLoaders/OpacityPreLoader';

const getRN = categoryId => {
  if (categoryId === 1) {
    return 'userBlackList.forms.removeUserBlackListByCustomersForm';
  } else if (categoryId === 2) {
    return 'userBlackList.forms.removeUserBlackListByExecutorsForm';
  }
  return 'userBlackList.forms.removeUserBlackListByExecutorsForm';
};

class RemoveUserBlackListPopUp extends Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      this.props.requestState.hasSuccessQuery
    ) {
      this.props.handleSuccessQuery();
      this.props.handleClose();
    }
  }

  render() {
    const getHeaderText = () => {
      if (this.props.blockedUserInfo) {
        if (this.props.categoryId === 1) {
          return (
            <p className="modal-title">
              {`Вы уверены что хотите удалить пользователя ${this.props.blockedUserInfo.username} из черного списка заказчиков?`}
            </p>
          );
        } else if (this.props.categoryId === 2) {
          return (
            <p className="modal-title">
              {`Вы уверены что хотите удалить пользователя ${this.props.blockedUserInfo.username} из черного списка исполнителей?`}
            </p>
          );
        }
        return null;
      }
      return null;
    };

    return (
      <WrapperPopUp {...this.props}>
        <div
          className="modal-dialog modal-gray modal-sm"
          role="document"
          onClick={e => e.stopPropagation()}
        >
          <div className="modal-content">
            {this.props.requestState.hasInProgress ? (
              <OpacityPreLoader />
            ) : null}
            <div className="modal-header text-center">
              <a
                aria-label="Close"
                className="close close-black"
                href=""
                onClick={e => {
                  e.preventDefault();
                  this.props.handleClose();
                }}
              />
              <i className="fa fa-exclamation-triangle modal-icon" />
              <h4 className="modal-title">
                <strong>Подтверждение</strong>
              </h4>
            </div>
            <div className="modal-body text-center">{getHeaderText()}</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-muted"
                onClick={this.props.handleClose}
              >
                Отмена
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  if (this.props.categoryId === 1) {
                    this.props.sendRequestDeleteInCustomerList();
                  } else if (this.props.categoryId === 2) {
                    this.props.sendRequestDeleteInExecutorList();
                  }
                }}
              >
                Разблокировать
              </button>
            </div>
          </div>
        </div>
      </WrapperPopUp>
    );
  }
}

RemoveUserBlackListPopUp.defaultProps = {
  blockedUserId: null,
  blockedUserInfo: null
};

RemoveUserBlackListPopUp.propTypes = {
  // IN
  categoryId: PropTypes.number.isRequired,
  blockedUserId: PropTypes.number,
  handleClose: PropTypes.func.isRequired,
  handleSuccessQuery: PropTypes.func.isRequired,

  // CONNECT STATE
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  blockedUserInfo: PropTypes.shape({
    username: PropTypes.string.isRequired
  }),

  // CONNECT DISPATCH
  sendRequestDeleteInCustomerList: PropTypes.func.isRequired,
  sendRequestDeleteInExecutorList: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, getRN(props.categoryId)),
  blockedUserInfo: selectItemById(
    state,
    'usersModule.collections.userCollection',
    props.blockedUserId
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequestDeleteInCustomerList: () =>
    dispatch(
      sendRequestDeleteInCustomerList(
        getRN(props.categoryId),
        props.blockedUserId
      )
    ),
  sendRequestDeleteInExecutorList: () =>
    dispatch(
      sendRequestDeleteInExecutorList(
        getRN(props.categoryId),
        props.blockedUserId
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemoveUserBlackListPopUp);



// WEBPACK FOOTER //
// ./src/components/UserBlackList/RemoveUserBlackListPopUp/RemoveUserBlackListPopUp.js